// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_gB","advertCardList_max6":"c-a_gC"};